import { BrowserModule } from '@angular/platform-browser';
import {Component, NgModule } from '@angular/core';
import {HttpClientModule} from '@angular/common/http';
import {Routes, RouterModule } from '@angular/router';


import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
//import { DashboardComponent } from './dashboard/dashboard.component';

import { CourseComponent } from './course/course.component';



import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { AuthService } from './auth.service';
import { AngularFontAwesomeModule } from 'angular-font-awesome';
import {UserService} from './user.service';
import {
  SocialLoginModule,
  AuthServiceConfig,
  GoogleLoginProvider,
} from "angular5-social-login";


//import { LabsComponent } from './dashboard/labs/labs.component';






import { LabsComponent } from './course/labs/labs.component';

import { UserprofileComponent } from './userprofile/userprofile.component';
import { LabPaneComponent } from './lab-pane/lab-pane.component';
import { CourseEnrollPaneComponent } from './course-enroll-pane/course-enroll-pane.component';
import { CourseProgressPaneComponent } from './course-progress-pane/course-progress-pane.component';

import { PageMainHeaderComponent } from './page-main-header/page-main-header.component';



//our root app component
//import {CommonModule} from '@angular/common';

// import the WindowRef provider
//import {WindowRef} from './WindowRef';












//import { WindowRef } from './WindowRef';

//import { WindowRef } from './WindowRef';

/*
import { Injectable } from '@angular/core';


function getWindow (): any {
    return window;
}

@Injectable()
export class WindowRefService {
  get nativeWindow (): any {
    return getWindow();
  }
}


export function windowFactory() {
  return window:
}
*/


//import { ChartsComponent } from './charts/charts.component';


const appRoutes: Routes  = [
  { path: '', component: LoginComponent },
  { path: 'course', component: CourseComponent},
  { path: 'userprofile', component: UserprofileComponent},

  { path: 'course/:labNumber', component: CourseComponent}



];


// Configs
  export function getAuthServiceConfigs() {
  let config = new AuthServiceConfig(
    [
      {
        id: GoogleLoginProvider.PROVIDER_ID,
        provider: new GoogleLoginProvider("428903156642-95i92o2l6f8e8cnd48k1apu1ib8vv81r.apps.googleusercontent.com")
      },
    ]);
  return config;
}





@NgModule({
  declarations: [
	AppComponent,
	LoginComponent,
	CourseComponent,
	LabsComponent,
	UserprofileComponent,
	CourseProgressPaneComponent,
	CourseEnrollPaneComponent,
	LabPaneComponent,
	PageMainHeaderComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    HttpClientModule,
    RouterModule.forRoot(appRoutes),
    AngularFontAwesomeModule,
    SocialLoginModule
  ],
  providers: [UserService, AuthService,
	  { provide: AuthServiceConfig, useFactory: getAuthServiceConfigs }
],
  bootstrap: [AppComponent]
})



export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts